import axios from "axios";
import { PaymentFilters, PaymentDTO, FindAllPaymentsResponseDTO } from "./dto";
import { PaymentService } from "./service";
import { keycloak } from "../../../lib/keycloak";

export class PaymentServiceImpl implements PaymentService {
    public findAllPayments(filters: PaymentFilters): Promise<FindAllPaymentsResponseDTO> {
        let url: string = "/api/payment?" +
            "pageSize=" + filters.pageSize +
            "&customerId=" + filters.customerId +
            "&page=" + filters.page +
            "&sort=" + filters.sort + 
            "&sortBy=" + filters.sortBy

        return axios({
            url: url,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public findPaymentById(id: string): Promise<PaymentDTO> {
        let url: string = "/api/payment/" + id
        return axios({
            url: url,
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public createPayment(request: PaymentDTO): Promise<void> {
        let url: string = "/api/payment"
        return axios({
            url: url,
            method: "POST",
            data: request,
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public createPaymentWithId(id: string): Promise<void> {
        let url: string = "/api/payment"
        return axios({
            url: url,
            method: "POST",
            data: {
                customer_id: id
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
    public deletePayment(id: string): Promise<void> {
        let url: string = "/api/payment/" + id
        return axios({
            url: url,
            method: "DELETE",
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then(() => undefined)
    }

}